export default __webpack_public_path__ + "images/models/27e5d1b94d7faf7682a6134ff93cf088.glb";